/* Only binds to FFTW calendar elements. No global event listeners or theme overrides. */
(() => {
  if (customElements.get('tsn-fftw-calendar')) return;
  class FFTWCalendar extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      const start = new Date(this.dataset.start);
      const end = new Date(this.dataset.end);
      const google = this.querySelector('[data-google]');
      const ics = this.querySelector('[data-ics]');
      if (!Number.isFinite(+start) || !Number.isFinite(+end) || end <= start) {
        google.hidden = true;
        this.querySelector('[data-calendar-error]').hidden = false;
        return;
      }
      const utc = date => date.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}Z$/, 'Z');
      const title = this.dataset.title || 'Flowers for the Weekend';
      const location = new URL(this.dataset.location || '/pages/flowersfortheweekend', window.location.origin).href;
      const description = this.dataset.description || '';
      const params = new URLSearchParams({ action: 'TEMPLATE', text: title, dates: `${utc(start)}/${utc(end)}`, details: description, location, ctz: 'Europe/London' });
      google.href = `https://calendar.google.com/calendar/render?${params}`;
      ics.hidden = false;
      const escape = value => value.replace(/\\/g, '\\\\').replace(/\r?\n/g, '\\n').replace(/,/g, '\\,').replace(/;/g, '\\;');
      // Fold by UTF-8 byte count, as required by RFC 5545 (not character count).
      const fold = line => {
        let result = '', current = '', bytes = 0;
        for (const character of line) {
          const length = new TextEncoder().encode(character).length;
          if (bytes + length > 74) { result += current + '\r\n'; current = ' '; bytes = 1; }
          current += character; bytes += length;
        }
        return result + current;
      };
      const lines = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//The Suffolk Nest//Flowers for the Weekend//EN', 'CALSCALE:GREGORIAN', 'METHOD:PUBLISH', 'BEGIN:VEVENT', `UID:fftw-${utc(start)}-${encodeURIComponent(title)}@thesuffolknest.com`, `DTSTAMP:${utc(new Date())}`, `DTSTART:${utc(start)}`, `DTEND:${utc(end)}`, `SUMMARY:${escape(title)}`, `DESCRIPTION:${escape(description)}`, `LOCATION:${escape(location)}`, `URL:${location}`, 'END:VEVENT', 'END:VCALENDAR'];
      ics.href = 'data:text/calendar;charset=utf-8,' + encodeURIComponent(lines.map(fold).join('\r\n') + '\r\n');
      ics.download = `flowers-for-the-weekend-${start.toISOString().slice(0, 10)}.ics`;
      ics.addEventListener('click', () => {
        this.querySelector('details').open = false;
      });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          this.querySelector('details').open = false;
          this.querySelector('summary').focus();
        }
      });
    }
  }
  customElements.define('tsn-fftw-calendar', FFTWCalendar);
})();
